import Vue from 'vue'
import VueRouter from 'vue-router'
import Apply from '../views/Apply.vue'
import Submissions from '../views/Submissions.vue'
import Home from '../views/Home.vue'
import AvailableInternships from '../views/AvailableInternships.vue'
import Admin from '../views/Admin.vue'
import ProfessorRecommendation from "../views/ProfessorRecommendation.vue"
import Export from "../views/export-pdf.vue"

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/available',
    name: 'AvailableInternships',
    component: AvailableInternships
  },
  {
    path: '/professor-recommendation',
    name: "ProfessorRecommendation",
    component: ProfessorRecommendation
  },
  {
    path: '/apply',
    name: 'Apply',
    component: Apply
  },
  {
    path: '/submissions',
    name: 'Submissions',
    component: Submissions
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin
  },
  {
    path: '/export',
    name: 'Export',
    component: Export
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
